<div class="container-card-basico card-lista-contatos">
  @if (listaContatos && listaContatos.length > 0) {
    <div class="cabecalho-lista">
      <div class="orientacao-base">
        <span>Para visualizar a lista completa de contatos,
          <button type="button" class="botao-base-completa" (click)="abrirBaseCompleta()">
            clique aqui
          </button>
        </span>
        @if (exibirReenvioIntegracao) {
          <app-button-padrao
            class="botao-reenvio-integracao"
            [label]="reenviandoIntegracao ? 'Reenviando...' : 'Enviar integração novamente'"
            width="auto"
            height="36px"
            padding="0 16px"
            borderRadius="8px"
            fontSize="var(--text-primary-font-10-12)"
            fontWeight="600"
            [disabled]="reenviandoIntegracao"
            (buttonClick)="reenviarIntegracao.emit()">
          </app-button-padrao>
        }
      </div>
      <span class="contador-contatos" matTooltip="Total">{{ quantidadeContatos ?? 0 }}</span>
    </div>
    <div class="area-tabela">
      <div class="table-container" #tableContainer>
        <mat-table [dataSource]="listaContatosTable" style="max-width: calc(100% - 20px)">

          <ng-container matColumnDef="contatoLido">
            <mat-header-cell *matHeaderCellDef aria-label="Status"></mat-header-cell>
            <mat-cell *matCellDef="let elemento" class="celula-status">
              @if (temIntegracao) {
                @let iconeInteg = iconeIntegracaoContato(elemento);
                @if (iconeInteg) {
                  <img class="icone-status" [class.icone-integ-cinza]="!!iconeInteg.classe"
                    [src]="iconeInteg.valor" [matTooltip]="iconeInteg.tooltip" alt="">
                }
              }
              @let iconeStatus = iconeStatusContato(tipoDisparo, elemento);
              @if (iconeStatus) {
                @if (iconeStatus.tipo === 'mat') {
                  <mat-icon [class.status-lido]="iconeStatus.classe === 'status-lido'"
                            [class.status-erro]="iconeStatus.classe === 'status-erro'"
                            [matTooltip]="iconeStatus.tooltip">{{ iconeStatus.valor }}</mat-icon>
                } @else {
                  <img class="icone-status" [src]="iconeStatus.valor" [matTooltip]="iconeStatus.tooltip" alt="">
                }
              }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="nomeContato">
            <mat-header-cell *matHeaderCellDef> Nome </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
                <span class="ellipse" [matTooltip]="elemento.nomeContato">{{ elemento.nomeContato ?? '--' }}</span>
                @if (!elemento.nomeContato?.trim()) {
                  <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Nome inválido" alt="Nome inválido">
                }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="cpf">
            <mat-header-cell *matHeaderCellDef> CPF/CNPJ </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
                <span class="ellipse" [matTooltip]="elemento.cpf | cpfCnpjMask">{{ elemento.cpf ? (elemento.cpf | cpfCnpjMask) : '--' }}</span>
                @if (!elemento.isCpfValido) {
                  <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Documento inválido" alt="Documento inválido">
                }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="telefone">
            <mat-header-cell *matHeaderCellDef> Número p/ envio </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
                <span class="ellipse" [matTooltip]="elemento.telefone | celularMask">{{ elemento.telefone ? (elemento.telefone | celularMask) : '--' }}</span>
                @if (!elemento.isContatoValido) {
                  <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="Número inválido" alt="Número inválido">
                }
                @if (elemento.isContatoRepetido) {
                  <img class="icone-aviso" src="assets/icones/advertencia.svg" matTooltip="Número repetido" alt="Número repetido">
                }
            </mat-cell>
          </ng-container>

          <ng-container matColumnDef="email">
            <mat-header-cell *matHeaderCellDef> E-mail </mat-header-cell>
            <mat-cell *matCellDef="let elemento">
                <span class="ellipse" [matTooltip]="elemento.email">{{ elemento.email ?? '--' }}</span>
                @if (!elemento.isEmailValido) {
                  <img class="icone-aviso" src="assets/icones/exclamacao.svg" matTooltip="E-mail inválido" alt="E-mail inválido">
                }
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns;" [class.linha-atualizada]="row.atualizadoAgora"></mat-row>
        </mat-table>
        @if (isCarregando && !fimDaLista) {
          <div style="display: flex; justify-content: center; padding: 16px;">
            <mat-progress-spinner mode="indeterminate" diameter="28"/>
          </div>
        }
        @if (fimDaLista && listaContatos.length > 0 && !isCarregando) {
          <!-- <p style="text-align: center; color: var(--primary); padding: 12px; font-size: 13px;">
            Todos os {{ quantidadeContatos }} contatos foram carregados
          </p> -->
        }
      </div>
    </div>
  } @else if (isCarregando) {
    <app-tabela-skeleton [qntdLinhas]="5"></app-tabela-skeleton>
  } @else {
      <div class="flex-direction-column center-center gap-15" style="width: 100%; height: 100%; padding: 16px 0;">
        <app-balao-informativo
          [titulo]="'Nenhum Contato Anexado'"
          [texto]="'Você ainda não anexou um arquivo com sua lista de contatos. Anexe um arquivo no painel à esquerda para carregar os contatos para disparo de mensagens.'"
          [width]="'249px'"
          [heigth]="'122px'"
        >
        </app-balao-informativo>
      </div>
    }
</div>
